export default __webpack_public_path__ + "static/media/ed_4.e5ae54c7.mp3";